import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IIVAXBusinessPostingGroup } from "src/models/General/IVAPostingGroup.models";

interface IVAXPostingGroupState {
  IVAxPostingGroups: IIVAXBusinessPostingGroup[];
  IVAxPostingGroupToEdit: IIVAXBusinessPostingGroup | null;
}

const initialState: IVAXPostingGroupState = {
  IVAxPostingGroups: [],
  IVAxPostingGroupToEdit: null,
};

const ivaXPostingGroupSlice = createSlice({
  name: "IVAXPostingGroup",
  initialState,
  reducers: {
    setIVAxPostingGroupList: (
      state,
      action: PayloadAction<IIVAXBusinessPostingGroup[]>
    ) => {
      state.IVAxPostingGroups = action.payload;
    },
    concatListIVAxPostingGroup: (
      state: IVAXPostingGroupState,
      action: PayloadAction<IIVAXBusinessPostingGroup[]>
    ) => {
      state.IVAxPostingGroups = [
        ...state.IVAxPostingGroups.concat(action.payload),
      ];
    },
    setIVAxPostingGroupToEdit: (
      state,
      action: PayloadAction<IIVAXBusinessPostingGroup | null>
    ) => {
      state.IVAxPostingGroupToEdit = action.payload;
    },
    addIVAxPostingGroup: (
      state,
      action: PayloadAction<IIVAXBusinessPostingGroup>
    ) => {
      state.IVAxPostingGroups.push(action.payload);
    },
    updateIVAxPostingGroup: (
      state,
      action: PayloadAction<IIVAXBusinessPostingGroup>
    ) => {
      let itemIndex = state.IVAxPostingGroups.findIndex(
        item => item.IVAXPostingGroupId === action.payload.IVAXPostingGroupId
      );
      if (itemIndex !== -1) state.IVAxPostingGroups[itemIndex] = action.payload;
    },
    deleteIVAxPostingGroup: (state, action: PayloadAction<number>) => {
      const newArray = state.IVAxPostingGroups.filter(
        item => item.IVAId !== action.payload
      );
      state.IVAxPostingGroups = newArray;
    },
  },
});

export const {
  setIVAxPostingGroupList,
  concatListIVAxPostingGroup,
  setIVAxPostingGroupToEdit,
  addIVAxPostingGroup,
  updateIVAxPostingGroup,
  deleteIVAxPostingGroup,
} = ivaXPostingGroupSlice.actions;

export default ivaXPostingGroupSlice.reducer;
